module.exports = __webpack_public_path__ + "static/media/System.d9e8c4fb.png";